import * as THREE from 'three';
import {Gyroscope} from '../../utils/Gyroscope.js';


export default class HotSpots {

    constructor(timeline) {

        this.config = {
            scaleInc:50,
            scale:80,
            margin: .8,
            closest_offset_dist:1000
        };

        this.config.closest_offset_vector = new THREE.Vector3(0,0,50000);

        this.timeline  = timeline;
        this.infoPanel = document.getElementById("InfoPanel");

        this.hotspotsArr = [];
        this.firstElement = [37600,0]; //[0]:posz on the track, [1]: index of the element
        this._currHotspot = null;
        this.hoverSprite;
        this.stats;
        this.camera;


        this.category_el = this.infoPanel.querySelector('.infopanel-category');
        this.title_el    = this.infoPanel.querySelector('.infopanel-title');
        // this.copy_el     = this.infoPanel.querySelector('.infopanel-copy');
        //this.img         = this.infoPanel.querySelector('.infopanel-image');
        this.button_more = this.infoPanel.querySelector('.infopanel-readmore')


        let self = this;
        
        $("#InfoPanel").addClass(this.category_el);

            this.button_more.addEventListener("click", function(){
           
            self.openArticleModal();
          });
      
    

        // listen for raytrace events
        document.addEventListener("raytrace_event", function (event) {
            self.doRayTraceEvent(event);
        });
        document.addEventListener("timeline_loaded", this.inits.bind(this));
        document.addEventListener("camera_event", function (event) {
            self.doCameraEvent(event);
            self.hideHotspot((event.detail.data.data));
        });


        return this;

    }

    inits(){

        document.removeEventListener("timeline_loaded", this.inits);
        this.data = timelineData.events;
        this.currHotspot = this.hotspotsArr[this.firstElement[1]];

        $("#InfoPanel").show();

        document.getElementById("close-button").addEventListener("click", function(){
            $("#InfoPanel").hide();
          });
        //if($(window).width() <= 700){this.currHotspot.children.material.color.set("#ffffff");} 

    }

    get trackwidth(){
        let w = 4000;
        if(window.innerWidth < 600) w = 1500;
        if(window.innerWidth > 600 && window.innerWidth < 1025) w = 3200;
        return w;
    }

    get trackcount(){
        return Object.keys(timelineData.events).length;
    }

    get data(){
        return this._data;
    }

    set data(data){

        let index     = 0;
        let cat_index = 0;
        this._data = data;


        let trackwidth   = this.trackwidth;
        let startpos     = -(trackwidth / 2);
        let hotspotwidth = 200;

        let firstElementIndex = 0;
        for(let category in this._data) {

            for (let item in this._data[category]) {

                let catwidth   = this.trackwidth / (this.trackcount);
                let itemObj = this.makeHotSpot(this._data[category][item]);
                let posz = Math.round((window.timeline.dates.depth / (timelineData.min - timelineData.max)) * (timelineData.min - parseInt(this._data[category][item].timestamp)));
                let itemstartpos = (startpos + (cat_index * catwidth));
                itemObj.position.y = 30000;
                itemObj.position.z = posz;
                itemObj.position.x = itemstartpos + (catwidth*.1) + Math.random() * (catwidth*.8);

                window.animationapi.registeranimation({
                    targets: itemObj.position,
                    y: 700,
                    delay: index * 10,
                    easing: 'easeOutQuad',
                    duration: 1000
                });

                this.timeline.scene.add(itemObj);
                if(this.firstElement[0] > posz){
                    this.firstElement[0] = posz;
                    this.firstElement[1] = firstElementIndex;
                }
                index++;
                firstElementIndex ++;
            }
            cat_index ++;

        }

    }

    makeHotSpot(dataconf) {

        // instantiate a loader
        let loader = new THREE.TextureLoader();

        let self        = this;
        let hotspotObj  = new Gyroscope();
       
        hotspotObj.name = dataconf.name;
        hotspotObj.userData.category    = dataconf.label_name;
        hotspotObj.userData.caption     = dataconf.caption;
        hotspotObj.userData.title       = dataconf.name;
        hotspotObj.userData.copy        = dataconf.copy;
        hotspotObj.userData.state       = "off";
        hotspotObj.userData.ontrack     = true;
        hotspotObj.userData.animID      = false;
        hotspotObj.userData.id          = dataconf.id;
        hotspotObj.userData.img         = dataconf.img;
        hotspotObj.userData.cdatelabel  = dataconf.cdatelabel;
        hotspotObj.userData.color       = dataconf.colour;

        // load a resource
        loader.load(
            // resource URL
            '/skins/default/graphics/timeline-circle.png',
            // Function when resource is loaded
            function ( texture ) {

                // do something with the texture
                texture.premultiplyAlpha = true;
                let material = new THREE.SpriteMaterial({
                    map: texture,
                    fog:false,
                    color:dataconf.colour
                });

                material.blending = THREE.CustomBlending;
                material.blendSrc = THREE.OneFactor;
                material.blendDst = THREE.OneMinusSrcAlphaFactor;
                material.map.needsUpdate = true;

                let spriteObject  = new THREE.Sprite(material);
                spriteObject.name = dataconf.name + '_sprite';
                spriteObject.userData.type = 'hotspot';

                material.color.set(dataconf.colour);

                spriteObject.scale.set(self.config.scale, self.config.scale, self.config.scale);

                hotspotObj.add(spriteObject);
                window.timeline.raytracemanager.addObject(spriteObject);

            },
            // onProgress callback currently not supported
            undefined,
            function ( error ) {

            }
        );

        this.hotspotsArr.push(hotspotObj);
        return hotspotObj;

    }

    
    doRayTraceEvent(rayEvent) {
        if (rayEvent.detail.type != undefined && rayEvent.detail.type.indexOf("hotspot") != -1) {
            switch (rayEvent.detail.interaction) {
                case "click":
                    this.resetImgContainer();
                    this.doClick(rayEvent.detail.rayobjectname);
                    
                    break;
                case "hover":
                    this.doHover(rayEvent.detail.rayobjectname);
                    break;
            }
        } else {
            this.doHoverOff();
           
        }

    }

    addClassToInfoPanel(category){

        $("#InfoPanel").addClass(category);
    }

    doClick(rayobjectname) {
      
        let rayobj = window.timeline.scene.getObjectByName(rayobjectname);

        if($(window).width() <= 700){
            this.currHotspot.children[0].material.color.set(this._currHotspot.userData.color);
        }

        this.currHotspot = rayobj.parent;

        if($(window).width() <= 700){rayobj.material.color.set('#ffffff');}

        this.addClassToInfoPanel(this.category_el);
        switch (rayobj.userData.state) {
            case "on":
                this.doOff(rayobj);
                break;
            case "off":
                this.doOn(rayobj);
                break;
        }

    }

    doHover(rayobjectname) {

        let self   = this;
        let rayobj = window.timeline.scene.getObjectByName(rayobjectname);

        if (this.hoverSprite != rayobj && rayobj.userData.state != "on") {

            this.doHoverOff();

            this.hoverSprite = rayobj;

            window.animationapi.registeranimation({
                targets: rayobj.scale,
                x: self.config.scale + this.config.scaleInc,
                y: self.config.scale + this.config.scaleInc,
                easing: 'easeOutQuad',
                duration:300
            });

        }

    }

    doHoverOff() {

        let self = this;
        if (this.hoverSprite && this.hoverSprite.userData.state != "on") {

            let rSprite = this.hoverSprite;
            this.hoverSprite.position.y = 0;

            window.animationapi.registeranimation({
                targets: rSprite.scale,
                x: self.config.scale,
                y: self.config.scale,
                easing: 'easeOutQuad',
                duration:300
            });

            this.hoverSprite = null;
        }

    }

    doOn(threeobj) {
        threeobj.userData.state = "on";
        threeobj.scale.x = this.config.scale + this.config.scaleInc;
        threeobj.scale.y = this.config.scale + this.config.scaleInc;
      
    }

    doOff(threeobj) {
        threeobj.userData.state = "off";
        threeobj.scale.x = this.config.scale;
        threeobj.scale.y = this.config.scale;

    }

    doCameraEvent(cam_event){
        this.camera = cam_event.detail.data.data;
        this.checkClosest(cam_event.detail.data.data);


    }

    get currHotspot(){
        return this._currHotspot;
    }

    set currHotspot(hotspot){
        this._currHotspot = hotspot;
        this.doInfoPanel();
    }

    checkClosest(z){
       
        this.resetImgContainer();

        let dist    = 2000000;
        let closest = this.hotspotsArr[0];
        let closesthdist;
        for(let hotspot in this.hotspotsArr){

            let h_dist = this.hotspotsArr[hotspot].position.clone().z - z;
            h_dist = (h_dist < 0)? h_dist * - 1 : h_dist;

            if(h_dist < dist){
                dist=h_dist;
                closest = this.hotspotsArr[hotspot];
            }


        }
        if($(window).width() <= 700){closest.children[0].material.color.set( this._currHotspot.userData.color);} 

        if(closest != this._currHotspot){
            if($(window).width() <= 700){this.currHotspot.children[0].material.color.set( this._currHotspot.userData.color);} 
            this.currHotspot = closest;
            if($(window).width() <= 700){this.currHotspot.children[0].material.color.set("#ffffff");} 
        }

    }

    doInfoPanel(){

        $(".infopanel-image").show();

        let $camera = (this.camera != undefined )?this.camera: 0;

      if( this._currHotspot.position.z > $camera ){
            $("#InfoPanel").show();
        }else{
            $("#InfoPanel").hide();
        }
     
        $("#InfoPanel").addClass(this._currHotspot.userData.id);
        $( "#InfoPanel" ).data("info",this._currHotspot.userData.id);

        this.category_el.textContent = this._currHotspot.userData.category;
        this.title_el.textContent    = this._currHotspot.name;
        // this.copy_el.insertAdjacentHTML('beforeend', this._currHotspot.userData.copy);
        this.img         = this.infoPanel.querySelector('.infopanel-image');
        this.img.src = this._currHotspot.userData.img;

        let world = this;

        let category = this.category_el.textContent.replace(/\s+/g, '');
        

        this.removeAllCategoryClassesToCanvas();
        this.removeAllCategoryClassesToInfoTitle();

        $(this.category_el).addClass(category.toLowerCase());
        $('#InfoPanel').addClass(category.toLowerCase());
        
        this.infoPanel.dataset.cssux = this._currHotspot.name;
        this.infoPanel.style.height  = '0px';
        this.infoPanel.style.width   = '0px';
        this.infoPanel.style.opacity = '0';

         window.animationapi.registeranimation({
            targets: this.infoPanel.style,
            width: '350px',
            height: '150px',
            opacity:1,
            easing: 'easeOutQuad',
            duration: 300
        });

    }

    openArticleModal() {
       
        $("#InfoPanel").hide();
        let date = "";
        if(this._currHotspot.userData.cdatelabel != undefined) {date = this._currHotspot.userData.cdatelabel }
        let completeContent = ` <div class="infopanel-container-modal">                               
                                    <div class="container-modal">
                                        <div class="infopanel-element-model left-align">
                                            <h3 class=" cdatelabel">` + date + `</h3>
                                            <h3 class=" infopanel-category">` + this._currHotspot.userData.title + `</h3>
                                            <p class="infopanel-title">` + this._currHotspot.userData.caption + `</p>
                                            
                                        </div>
                                        <div class="infopanel-element-model right-align">
                                            <img class="infopanel-image " src="` + this._currHotspot.userData.img + `" />
                                        </div>
                                    </div>
                                </div>`;


       $.fancybox.open( {
            src: completeContent,
            type: 'inline',
            opts: {
                smallBtn : true,
                afterLoad : ( instance, current ) => {
                   
                },
                
                afterClose: () => {
                   // this.removeAppend();
                   $("#InfoPanel").fadeIn();
                }
            }
        } );
    }

    detectLangBrowse(){
        var ln = ""+window.location;

        if(ln.includes("/ar/")){
            return true;
        }else{
            return false;
        }
    }
    removeAllCategoryClassesToCanvas(){
        $('#InfoPanel').removeClass("internationalmissions");
        $('#InfoPanel').removeClass("people");
        $('#InfoPanel').removeClass("partnership");
        $('#InfoPanel').removeClass("programdevelopment");

    }

    removeAllCategoryClassesToInfoTitle(){
        $('.infopanel-category').removeClass("internationalexpertmissions");
        $('.infopanel-category').removeClass("people");
        $('.infopanel-category').removeClass("partnerships");
        $('.infopanel-category').removeClass("programdevelopment");
        $('.infopanel-category').removeClass("بعثاتالخبراءالدوليين");
        $('.infopanel-category').removeClass("تطويرالبرنامجالنوويللدولة");
        $('.infopanel-category').removeClass("المشاركاتالمجتمعية");
        $('.infopanel-category').removeClass("الشراكات");
        
        

    }

    createDummyData(){

        let data = [];
        let start_ts = 1208709160;
        let end_ts   = 1572453160;

        let start_date = new Date(start_ts * 1000);
        let end_date  = new Date(end_ts * 1000);

        let start_year = start_date.getUTCFullYear();
        let end_year   = end_date.getUTCFullYear();

        let start_year_ts = Date.UTC(start_year,'00','01','00','00','01');
        let end_year_ts = Date.UTC(end_year + 1,'00','01','00','00','01');

        let dummy_count = 250;
        let incval = (end_ts - start_ts) / dummy_count;

        for(let i=0;i<dummy_count;i++){
            let ts =start_ts + (incval * i);
            data.push({category:Math.ceil(Math.random() * 4) ,title:`hello world ${i}`, timestamp: ts});
        }

        return data;

    }
    resetImgContainer(){
        $( ".infopanel-image" ).remove();
        $( ".img-containerpanel" ).append('<img class="infopanel-image" src=""/>');
    }
    update(posCam){

        posCam = (window.innerWidth < 600)? posCam + 2000 : posCam + 1800 ;

        this.hideHotspot(posCam);

    }
    hideHotspot(posCam){
        //$("#InfoPanel").removeClass("no-transform");
      
        for(let i = 0 ; i <  this.hotspotsArr.length ;i++){
                  
            if(posCam > this.hotspotsArr[i].position.z ){
               
                if(this.hotspotsArr[i].userData.ontrack == true){

                    if($(window).width() <= 700){
                        this.hotspotsArr[i].children[0].material.color.set( this.hotspotsArr[i].userData.color);
                        if($("#InfoPanel").data("info") === this.hotspotsArr[i].userData.id ) {
                            $("." + this.hotspotsArr[i].userData.id).hide();
                        }
                        $('#InfoPanel').removeClass(this.hotspotsArr[i].userData.id); 
                    } 


                    let animID = this.hotspotsArr[i].userData.animID;

                    this.hotspotsArr[i].userData.animID = window.animationapi.registeranimation({
                        targets: this.hotspotsArr[i].position,
                        y: 5000,
                        easing: 'easeOutQuad',
                        duration: 3000
                    }, animID);

                    this.hotspotsArr[i].userData.ontrack = false;
                }

            }else{
                if(this.hotspotsArr[i].userData.ontrack == false){
                    this.hotspotsArr[i].userData.ontrack = true;
                    let animID = this.hotspotsArr[i].userData.animID;
                    
                    this.hotspotsArr[i].userData.animID = window.animationapi.registeranimation({
                        targets: this.hotspotsArr[i].position,
                        y: 700,
                        easing: 'easeOutQuad',
                        duration: 1000
                    }, animID);
                  

                    if($(window).width() <= 700){
                        $('#InfoPanel').removeClass(this.hotspotsArr[i].userData.id); 
                    }

                }


            }


        }
    }

}




